// Infosivun allekkaiset sisältösivut: korostaa valintarivissä osion, jota luetaan.
export function setupPageSections(): void {
  const nav = document.querySelector<HTMLElement>(".page-sections .page-nav");
  if (!nav) return;
  const links = new Map<string, HTMLAnchorElement>();
  for (const a of nav.querySelectorAll<HTMLAnchorElement>("a[href^='#']")) links.set(a.hash.slice(1), a);
  const sections = [...document.querySelectorAll<HTMLElement>(".page-section")].filter((s) =>
    links.has(s.id),
  );
  const first = sections[0];
  const last = sections[sections.length - 1];
  if (!first || !last) return;

  const mark = (id: string) => {
    for (const [key, a] of links) {
      if (key === id) a.setAttribute("aria-current", "location");
      else a.removeAttribute("aria-current");
    }
  };

  // Valittu osio (napautus tai osoitteen ankkuri) pysyy korostettuna, kunnes käyttäjä vierittää itse:
  // lyhyttä loppuosiota ei voi vierittää ylös asti, jolloin sijaintiin perustuva päättely osuisi ohi.
  let pinned: string | null = links.has(location.hash.slice(1)) ? location.hash.slice(1) : null;

  // Näkyvä osio on viimeinen, jonka otsikko on ohittanut valintarivin alareunan.
  const update = () => {
    if (pinned) return mark(pinned);
    const line = nav.getBoundingClientRect().bottom + 8;
    let current = first;
    for (const s of sections) if (s.getBoundingClientRect().top <= line) current = s;
    const root = document.documentElement;
    const atBottom =
      root.scrollHeight > window.innerHeight && window.innerHeight + window.scrollY >= root.scrollHeight - 2;
    mark((atBottom ? last : current).id);
  };

  nav.addEventListener("click", (e) => {
    const a = (e.target as Element).closest<HTMLAnchorElement>("a[href^='#']");
    if (!a) return;
    pinned = a.hash.slice(1);
    mark(pinned);
  });
  const release = () => {
    pinned = null;
  };
  for (const ev of ["wheel", "touchstart", "keydown"])
    window.addEventListener(ev, release, { passive: true });

  let queued = false;
  window.addEventListener(
    "scroll",
    () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        update();
      });
    },
    { passive: true },
  );
  update();
}
